import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptBR from './pt_BR/translation.json';

i18n
  .use(initReactI18next)
  .init({
    lng: 'pt_BR',
    fallbackLng: 'pt_BR',
    supportedLngs: ['pt_BR'],
    nonExplicitSupportedLngs: false,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    resources: {
      pt_BR: {
        translation: ptBR,
      },
    },
    keySeparator: '>',
    nsSeparator: '|',
  });

export default i18n;
